module.exports = __webpack_public_path__ + "img/cover-erik.74c401ce.png";